import http from './http-common';

class HSCodeService {
  getAll() {
    return http.get('/hsCode');
  }
  getYarnContractImportLC() {
    return http.get('/hsCode/yarnContractHSCode');
  }
}

export default new HSCodeService();
